// The MIT License (MIT)
//
// Copyright (c) 2018-2026 Camptocamp SA
//
// Permission is hereby granted, free of charge, to any person obtaining a copy of
// this software and associated documentation files (the "Software"), to deal in
// the Software without restriction, including without limitation the rights to
// use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of
// the Software, and to permit persons to whom the Software is furnished to do so,
// subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in all
// copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS
// FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR
// COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER
// IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
// CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
import ngeoInteractionMeasureArea from 'ngeo/interaction/MeasureArea';
import ngeoInteractionMobileDraw from 'ngeo/interaction/MobileDraw';
/**
 * Interaction dedicated to measure Area on mobile devices.
 *
 * @private
 * @hidden
 */
class MeasureAreaMobile extends ngeoInteractionMeasureArea {
    /**
     * @param {import('ngeo/misc/filters').unitPrefix} format The format function
     * @param {angular.gettext.gettextCatalog} gettextCatalog Gettext catalog.
     * @param {import('ngeo/interaction/Measure').MeasureOptions} [options] Options
     */
    constructor(format, gettextCatalog, options = {}) {
        Object.assign(options, { displayHelpTooltip: false });
        super(format, gettextCatalog, options);
    }
    /**
     * @param {import('ol/style/Style').StyleLike} style The sketchStyle used for the drawing
     *    interaction.
     * @param {import('ol/source/Vector').default<import('ol/geom/Polygon').default>} source Vector source.
     * @returns {ngeoInteractionMobileDraw} The interaction
     */
    createDrawInteraction(style, source) {
        const interaction = new ngeoInteractionMobileDraw({
            type: 'Polygon',
            style: style,
        });
        interaction.set('name', 'PolygonMobileDraw');
        return interaction;
    }
}
export default MeasureAreaMobile;
//# sourceMappingURL=MeasureAreaMobile.js.map